import * as React from "react";

function Vendors(props) {
  return (
    <svg width={24} height={24} fill="none" {...props}>
      <path
        d="M12.75 13.5a.75.75 0 101.5 0c0-.827-.673-1.5-1.5-1.5a.75.75 0 10-1.5 0c-.827 0-1.5.673-1.5 1.5V15c0 .827.673 1.5 1.5 1.5h1.5V18l-1.5-.002a.765.765 0 00-.75-.732h-.016A.738.738 0 009.75 18c0 .827.673 1.5 1.5 1.5a.75.75 0 101.5 0c.827 0 1.5-.673 1.5-1.5v-1.5c0-.827-.673-1.5-1.5-1.5h-1.5v-1.5h1.5z"
        stroke="none"
        fill="currentColor"
      />
      <path
        d="M14.04 8.515c1.597-1.893 2.772-5.445 3.178-6.8A.75.75 0 0016.5.75h-9a.752.752 0 00-.718.965c.406 1.355 1.581 4.907 3.177 6.8-3.563.912-6.209 4.141-6.209 7.985v6c0 .414.335.75.75.75h15a.75.75 0 00.75-.75v-6c0-3.844-2.646-7.072-6.21-7.985zM8.529 2.25h6.944c-1.02 3.007-2.573 6-3.472 6-.9 0-2.452-2.993-3.473-6zm10.222 19.5H5.25V16.5A6.758 6.758 0 0112 9.75a6.758 6.758 0 016.75 6.75v5.25z"
        fill="currentColor"
        stroke="none"
      />
    </svg>
  );
}

const VendorsIcon = React.memo(Vendors);
export default VendorsIcon;
